import { __assign } from "tslib";
import { ButtonAlign } from '../../../types';
import { getUpgradedColor } from '../../color/get-upgraded-color';
import { defaultLink, defaultBackgroundColor } from '../../defaults';
import { verifyOrFallbackColor } from '../../verify-or-fallback';
import { extractTextStyles } from '../extract-text-styles';
import { BIG_WIDTH, BIG_WIDTH_PADDING, SMALL_WIDTH, SMALL_WIDTH_PADDING, } from './constants';
import { makePaddingString } from './make-padding-string';
export var extractButton = function (_a) {
    var customStyles = _a.customStyles, defaultStyles = _a.defaultStyles, _b = _a.experiments, experiments = _b === void 0 ? {} : _b, isRtl = _a.isRtl, region = _a.region, _c = _a.minCalculatedColumnWidth, minCalculatedColumnWidth = _c === void 0 ? undefined : _c, _d = _a.defaultButtonAlignment, defaultButtonAlignment = _d === void 0 ? ButtonAlign.center : _d;
    var borderStyle = defaultStyles.borderStyle || 'solid';
    var borderWidth = customStyles.borderWidth || defaultStyles.borderWidth || '0px';
    var borderColor = customStyles.borderColor || defaultStyles.borderColor || 'transparent';
    var borderRadius = customStyles.borderRadius || defaultStyles.borderRadius;
    var backgroundColor = verifyOrFallbackColor(defaultBackgroundColor)(getUpgradedColor(customStyles.backgroundColor ||
        defaultStyles.backgroundColor ||
        'transparent'));
    var padding = {
        top: defaultStyles.paddingTop,
        right: defaultStyles.paddingRight,
        bottom: defaultStyles.paddingBottom,
        left: defaultStyles.paddingLeft,
    };
    if (minCalculatedColumnWidth) {
        if (minCalculatedColumnWidth <= SMALL_WIDTH) {
            padding = __assign(__assign({}, padding), { right: SMALL_WIDTH_PADDING, left: SMALL_WIDTH_PADDING });
        }
        else if (minCalculatedColumnWidth <= BIG_WIDTH) {
            padding = __assign(__assign({}, padding), { right: BIG_WIDTH_PADDING, left: BIG_WIDTH_PADDING });
        }
    }
    return __assign(__assign({}, extractTextStyles(customStyles, defaultStyles)), { align: customStyles.align ||
            region.data.buttonAlign ||
            defaultStyles.buttonAlign ||
            defaultButtonAlignment, backgroundColor: backgroundColor, border: borderStyle + " " + borderWidth + " " + borderColor, borderRadius: borderRadius, href: region.data.url || defaultLink, innerPadding: makePaddingString({ padding: padding, experiments: experiments }), text: region.data.label, isRtl: isRtl });
};
//# sourceMappingURL=extract-button.js.map